import type { PropsWithChildren } from "react";

import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CONTACTS_MODAL_ENRICHMENT_TITLE } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";

type Props = PropsWithChildren;

const CompanyColumnPickerHead = ({ children }: Props) => {
    return (
        <Flex
            justifyContent="space-between"
            margin="0 0 10px"
            padding="10px 0"
        >
            <Text fontVariant="subtitle1">{translate(CONTACTS_MODAL_ENRICHMENT_TITLE)}</Text>

            {children}
        </Flex>
    );
};

export default CompanyColumnPickerHead;
